import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { campaignRPO } from "campaign/repository"
import { campaignActionCreator } from "campaign/store/actions"
import { messageSVC } from "message/service"

export function loadListCampaignEstimates(isForecast: boolean): Promise<void> {
  return new Promise<void>(async resolve => {
    try {
      const filteredEntities = isForecast
        ? getStore().getState().campaign.forecastList.filteredEntities
        : getStore().getState().campaign.campaignList.filteredEntities
      if (filteredEntities.length === 0) {
        return
      }
      getStore().dispatch(campaignActionCreator.setList(isForecast, false, { isLoadingEstimates: true }))
      const estimates = await campaignRPO.getCampaignsGlobalForecast(filteredEntities.map(c => c.id))
      getStore().dispatch(campaignActionCreator.setListCampaignsEstimates(isForecast, false, estimates))
      resolve()
    } catch (error) {
      console.error(error)
      getStore().dispatch(campaignActionCreator.setList(isForecast, false, { isLoadingEstimates: false }))
      messageSVC.error(translate("campaign.estimates.error"))
      resolve()
    }
  })
}
